import { Avatar, AvatarFallback } from "../ui/avatar";
import pkg from "../../../package.json";

import {
  logout,
  selectFirstName,
  selectIsAuth,
  selectLastName,
} from "@/features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { useEffect, useState } from "react";

import { getCookie } from "@/utils/cookieUtils";
import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { SettingsDialog } from "../Settings/SettingsDialog";

export const AvatarDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [fallback, setFallback] = useState<string>("");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const isAuth = useAppSelector(selectIsAuth);
  const firstName = useAppSelector(selectFirstName);
  const lastName = useAppSelector(selectLastName);
  const username = getCookie("username");

  // Redirect to /login if not authenticated
  useEffect(() => {
    if (!isAuth) {
      navigate("/login", { replace: true });
    }
  }, [isAuth, navigate]);

  /**
   * Dispatches the logout action to revoke auth tokens
   */
  const handleLogout = async () => {
    await dispatch(logout());
  };

  /**
   * Helper function to retrieve first letter of username for callback avatar
   */
  const getAvatarFallback = () => {
    let fallback = "";
    const usernameCookie = getCookie("username");

    if (usernameCookie) {
      fallback = usernameCookie[0].toUpperCase();
      setFallback(fallback);
    } else {
      setFallback("?");
    }
  };

  useEffect(() => {
    getAvatarFallback();
  }, []);

  const infoSection = () => {
    return (
      <div>
        <p id="chat-header-name" className="font-light text-l">
          <span className="font-semibold">Username: {username}</span>
          {(firstName || lastName) && (
            <>
              <br />
              Name: {firstName} {lastName}
            </>
          )}
          <br />
          Version: {pkg.version}
        </p>
      </div>
    );
  };
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Avatar className="w-10 h-10">
            <AvatarFallback className="bg-blue-100">
              {fallback.length > 0 && fallback}
            </AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="bottom" align="start">
          <DropdownMenuLabel>{infoSection()}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <a href={`${window.location.origin}/admin/`} target="_blank" rel="noopener noreferrer">
              Admin Console
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setTimeout(() => setSettingsOpen(true), 0)}>
            Settings
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleLogout}>Logout</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <SettingsDialog open={settingsOpen} onOpenChange={setSettingsOpen} />
    </>
  );
};
